// import queryString from "query-string";
import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { IProvinceCity } from "../../../../types/area.interface";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [selectedProvince, setSelectedProvince] = useState<IProvinceCity>();
  const [selectedCity, setSelectedCity] = useState<IProvinceCity>();

  const { requestClient, setRequestClient } = useContext(Context.ClientScreen);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.getMethod.common.findProvinceCity({})
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllProvince, selectedProvince],
    () =>
      api.getMethod.common.findProvinceCity({
        provinceId: selectedProvince?._id,
      })
  );
  // const userType = utils.stringHexConversion.reverse(
  //   Cookies.get(constants.USER.TYPE)
  // );

  // const getAllCompanyForAdmin = useQuery(
  //   [values.useQueryKeys.getAllCompany],
  //   () => api.post.administrator.getAllCompany({}),
  //   { enabled: userType === "ADMIN" }
  // );
  // const getAllCompanyForSuperAgent = useQuery(
  //   [values.useQueryKeys.getAllCompany, "super-agent"],
  //   () => api.post.superAgent.findCompany({}),
  //   { enabled: userType === "SUPER_AGENT_SCHOOL" }
  // );

  // const getAllCompany =
  //   userType === "ADMIN" ? getAllCompanyForAdmin : getAllCompanyForSuperAgent;

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================
  // const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
  //   (item: any) => ({
  //     ...item,
  //     companyName: item?.companyInformation?.companyName,
  //   })
  // );

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        <CustomView.Row className="form-row  row-align-start">
          <CustomView.Column medium={12}>
            <CustomDropDownSearch
              items={getAllProvince?.data?.result}
              itemName="title"
              onSelectItem={(event) => {
                setSelectedProvince(event);
                setSelectedCity(undefined);
              }}
              placeHolder="انتخاب استان"
              label="استان"
              defaultItem={selectedProvince}
              isSearch
            />
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <CustomDropDownSearch
              items={getAllCity?.data?.result}
              itemName="title"
              onSelectItem={(event) => {
                setSelectedCity(event);
                setRequestClient!({
                  ...requestClient,
                  county: event?._id,
                });
              }}
              placeHolder="انتخاب شهر"
              label="شهر"
              defaultItem={selectedCity}
              isSearch
            />
          </CustomView.Column>
        </CustomView.Row>

        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestClient!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default FilterAgent;
